import React, { useEffect, useState } from "react";
import { VirsionCheck } from "../../Helpers/Common"; //
import { ImgIcons, SVGIcons } from "../../Helpers/Common";
import { SendContactUs, userprofile } from "../../Model/Users"; //Include Home
import Profilemenu from "../Profile_menu/Profilemenu";
import { Metadata } from "../Metadata/Metadata";
import BarLoader from "react-spinners/BarLoader";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));
export default function ContactUs(props) {
    const [VirsionCheckData, setVirsionCheckData] = useState(0);
    const [VirsionCheckDataloaded, setVirsionCheckDataloaded] = useState(0);
    const [userData, setuserData] = useState(0);
    const [userchecked, setuserchecked] = useState(0);
    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [messageError, setMessageError] = useState(false);
    const [queryError, setQueryError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [contactData, setContactData] = useState({
        name: "",
        email: "",
        subject: "No-Select",
        description: "",
        mobile: "",
    });
    const [enableSubmitbtn, setEnableSubmitBtn] = useState(false);
    function isValidEmail(email) {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            email
        );
    }
    const getData = () => {
        VirsionCheck().then((vcheckres) => {
            let data = {
                seesionID: localStorage.getItem("session_id"),
                userID: localStorage.getItem("userID")
            }
            userprofile(data).then((userDatares) => {
                if (userDatares.data.message == "session_expired") {
                    //Redirect To login page.
                    this.props.navigate("/createaccount");
                } else {
                    var userDatares = JSON.parse(userDatares.data.message);
                    setVirsionCheckData(vcheckres);
                    setVirsionCheckDataloaded(true);
                    setuserData(userDatares.user_data);
                    setuserchecked(userDatares.user_data.is_child);
                }
            });
        });
    };
    useEffect(() => {
        getData();
    }, [enableSubmitbtn]);
    const handleChange = (event) => {
        if (!event.target.name == "mobile") {
            return;
        } else {
            if (event.target.value.trim() == "" || event.target.value == "No-Select") {
                setContactData((curr) => ({
                    ...curr,
                    [event.target.name]: event.target.value,
                }));
                setEnableSubmitBtn(false);
            } else {
                setEnableSubmitBtn(true);
            }
        }
        setContactData((curr) => ({
            ...curr,
            [event.target.name]: event.target.value,
        }));
        if (
            isValidEmail(contactData.email) == false ||
            isNaN(contactData.mobile) == true
        ) {
            setEnableSubmitBtn(false);
        } else {
            setEnableSubmitBtn(true);
        }
        if (
            contactData.name.trim() == "" ||
            contactData.subject.trim() == "" ||
            contactData.description.trim() == "" ||
            contactData.name?.length <= 1 ||
            contactData.description?.length <= 1
        ) {
            setEnableSubmitBtn(false);
        }
    };
    const submitForm = () => {
        SendContactUs(contactData).then((res) => {
            if (JSON.parse(res.data).success == true) {
                setContactData("");
                setEnableSubmitBtn(false);
                toast("Your information has been successfully submited", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    draggable: true,
                    theme: "light",
                    className: "toast-message-newsletter",
                });
            }
        });
    };
    return (
        <>
            <Metadata page="CONTACT-US" />
            <ToastContainer />
            <div className="setting-main">
                <div className="innerBanner mb-0 dD-block">
                    <div className="policy-title">
                        <h1>
                            Contact <span className="red"> Us</span>
                        </h1>
                    </div>
                </div>
                <div className="contact-us">
                    <a href="https://wa.me/919738274274?text=Hi" target="_blank">
                        <img
                            src={ImageData["contactusImg.png"]}
                            alt="DocuBay"
                            className="w-100"
                        />
                    </a>
                </div>
                <div className="temp51">
                    <div className="temp51-inn">
                        <div className="temp51-head">
                            <h3>Get in touch with us</h3>
                            <p>Leave your query here &amp; we will contact you.</p>
                        </div>
                        <div className="temp51-area">
                            <div className="formField">
                                <input
                                    type="text"
                                    name="name"
                                    spellCheck="false"
                                    autoComplete="off"
                                    placeholder="Name"
                                    value={contactData.name || ""}
                                    onChange={(e) => handleChange(e)}
                                    onKeyUp={() =>
                                        contactData.name?.length <= 1 || contactData.name == ""
                                            ? setNameError(true)
                                            : setNameError(false)
                                    }
                                    required
                                />
                                {nameError ? (
                                    <>
                                        <div className="error">
                                            <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                                            <p>Please Enter a Name</p>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                            <div className="formField">
                                <input
                                    type="tel"
                                    name="mobile"
                                    spellCheck="false"
                                    autoComplete="off"
                                    placeholder="Mobile"
                                    value={contactData.mobile || ""}
                                    onChange={(e) => handleChange(e)}
                                    onKeyUp={() =>
                                        isNaN(contactData.mobile) == true ||
                                            contactData.mobile == ""
                                            ? setPhoneError(true)
                                            : setPhoneError(false)
                                    }
                                    pattern="[0-9]"
                                />
                                {phoneError ? (
                                    <div className="error">
                                        <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                                        <p>Please Enter a valid Mobile number</p>
                                    </div>
                                ) : null}
                            </div>
                            <div className="formField">
                                <input
                                    type="email"
                                    name="email"
                                    spellCheck="false"
                                    autoComplete="off"
                                    placeholder="Enter email address"
                                    value={contactData.email || ""}
                                    onChange={(e) => handleChange(e)}
                                    onKeyUp={() =>
                                        !isValidEmail(contactData.email)
                                            ? setEmailError(true)
                                            : setEmailError(false)
                                    }
                                    required
                                />
                                {emailError ? (
                                    <>
                                        <div className="error">
                                            <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                                            <p>Please Enter a valid Email Address</p>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                            <div className="formField">
                                <select
                                    name="subject"
                                    className="selectContact"
                                    value={contactData.subject || ""}
                                    onChange={(e) => handleChange(e)}
                                    onMouseUp={() =>
                                        contactData.subject == "No-Select"
                                            ? setQueryError(true)
                                            : setQueryError(false)
                                    }
                                    required
                                >
                                    <option>Select</option>
                                    <option value="Others">Others</option>
                                    <option value="Query">Query</option>
                                    <option value="Feedback">Feedback</option>
                                    <option value="Report Issue">Report Issue</option>
                                </select>
                                {queryError ? (
                                    <>
                                        <div className="error">
                                            <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                                            <p>Please select an option</p>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                            <div className="formField">
                                <textarea
                                    name="description"
                                    rows={4}
                                    placeholder="Message"
                                    className="textarea-form"
                                    value={contactData.description || ""}
                                    onChange={(e) => handleChange(e)}
                                    onKeyUp={() =>
                                        contactData.description?.length <= 1 ||
                                            contactData.description == ""
                                            ? setMessageError(true)
                                            : setMessageError(false)
                                    }
                                    required
                                />
                                {messageError ? (
                                    <>
                                        <div className="error">
                                            <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                                            <p>Please Enter a Valid Message</p>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                            <div className="formField mt-24 mb-24">
                                <button
                                    type="submit"
                                    id="sendEnquiryBtn"
                                    className={!enableSubmitbtn ? "btn-black" : "btn-red"}
                                    onClick={submitForm}
                                    disabled={!enableSubmitbtn}
                                >
                                    Submit
                                </button>
                            </div>
                            <h6>
                                If you need further assistance or have any queries, please email
                                us at{" "}
                                <a href="mailto:contact@docubay.com">contact@docubay.com</a>{" "}
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dD-block">
                <Profilemenu versioncheck={VirsionCheckData} profile={userData} />
            </div>
        </>
    );
}